import React, { Component } from "react";
import { ConfiguracionPlantillaStore } from "../../../containers/comisionesMembresiaConfiguracion/configuracionPlantilla/ConfiguracionPlantilla.store";
import { ConfiguracionPlantillaDispatcher } from "../../../containers/comisionesMembresiaConfiguracion/configuracionPlantilla/ConfiguracionPlantilla.dispatcher";
import ConfiguracionPlantillaTable from "./ConfiguracionPlantilla.table";
import MembresiaPlantilla, {
  GerenteRegional,
  LiderComercial,
  AsesorClub
} from "../../../../types/MembresiaPlantilla";
import {
  successNotification,
  errorNotification
} from "../../../../utils/notifications";
import FormBuilderModal from "../../common/formBuilderModal/formBuilderModal";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import { Button } from "reactstrap";
import { empleadoFormConfig } from "./ConfiguracionPlantillaEmpleado.form";
import { asesorFormConfig } from "./ConfiguracionPlantillaAsesor.form";
import { bajaFormConfig } from "./ConfiguracionPlantillaBaja.form";
import {
  metasPresupuestadasFormConfig,
  metasFormConfig
} from "./ConfiguracionPlantillaMetas.form";
import { filtrosFormConfig } from "./ConfiguracionPlantillaFiltros.form";
import { getEmployeesBasicCatalog } from "../../../actions/catalogs";
import { downloadReporteMetasClub } from "../../../actions/comisionMembresia";
import { Styled } from "../../../../toolkit/decorators/Artifact";
import s from "./styles.scss";
import ConfirmModal from "../../common/confirmModal/confirmModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import ITypeSelectBuilder from "../../../../toolkit/baseForms2/iTypeSelectBuilder/ITypeSelectBuilder";

interface Props
  extends ConfiguracionPlantillaStore,
    ConfiguracionPlantillaDispatcher {}

interface State {
  periodo: string;
  popupEmpleadoOpen: boolean;
  popupEmpleadoTitle: string;
  popupEmpleadoMessage: string;
  popupEmpleadoFormConfig: any;
  popupEmpleadoInit: any;
  popupEmpleadoHandler: any;
  popupEmpleadoDanger: string;
  confirmModalOpen: boolean;
  confirmModalTitle: string;
  confirmModalMessage: string;
  confirmModalHandler: any;
  gerente: GerenteRegional;
  lider: LiderComercial;
  asesor: AsesorClub;
  plantilla: MembresiaPlantilla;
  guardar: boolean;
  loadingReporte: boolean;
  filtros: {
    tipoBusqueda: string;
    region: number;
    club: number;
  };
}

@Styled(s)
export default class ConfiguracionPlantillaComponent extends Component<
  Props,
  State
> {
  state: State = {
    periodo: `${new Date().getFullYear()}-${String(
      new Date().getMonth() + 1
    ).padStart(2, "0")}-01`,
    popupEmpleadoOpen: false,
    popupEmpleadoTitle: "",
    popupEmpleadoMessage: "",
    popupEmpleadoFormConfig: null,
    popupEmpleadoInit: null,
    popupEmpleadoHandler: null,
    popupEmpleadoDanger: null as string,
    confirmModalOpen: false,
    confirmModalTitle: "",
    confirmModalMessage: "",
    confirmModalHandler: null,
    gerente: null as GerenteRegional,
    lider: null as LiderComercial,
    asesor: null as AsesorClub,
    plantilla: null as MembresiaPlantilla,
    guardar: false,
    loadingReporte: false,
    filtros: {
      tipoBusqueda: "",
      region: null,
      club: null
    }
  };

  componentDidMount() {
    this.loadPlantilla();
  }

  loadPlantilla = async () => {
    const { periodo } = this.state;
    const preview = await this.props.getPlantillaByPeriodo(periodo);

    if (preview.fulfilled) {
      const plantilla = preview.comisionMembresiaPlantilla;
      const generada = !!plantilla && !!plantilla.id;

      this.setState({ plantilla, guardar: !generada });
      successNotification("Plantilla cargada correctamente");
    } else {
      errorNotification(preview.gettingComisionMembresiaPlantillaError);
    }
  };

  onEditGerente = (gerente: GerenteRegional) => {
    this.setState({
      popupEmpleadoOpen: true,
      popupEmpleadoTitle: "Gerente Regional",
      popupEmpleadoMessage: "Seleccione al Gerente Regional",
      popupEmpleadoFormConfig: empleadoFormConfig,
      popupEmpleadoInit: { idUser: gerente.idUser },
      popupEmpleadoHandler: this.handleSaveGerente,
      popupEmpleadoDanger: this.state.plantilla.confirmado
        ? "Plantilla confirmada: Los alcances del Gerente se asignarán al que está especificando."
        : null,
      gerente: gerente
    });
  };

  onDeleteGerente = (gerente: GerenteRegional) => {
    const { plantilla } = this.state;

    if (plantilla.confirmado) {
      errorNotification("La plantilla ya está confirmada");
      return;
    }

    if (!gerente.idUser) {
      errorNotification("No ha seleccionado al Gerente Regional");
      return;
    }

    this.setState({
      confirmModalOpen: true,
      confirmModalTitle: "Eliminar Gerente Regional",
      confirmModalMessage: `¿Está seguro de eliminar al Gerente ${gerente.nombreEmpleado} de la Región ${gerente.numeroRegion}?`,
      confirmModalHandler: () => this.handleDeleteGerente(gerente),
      gerente: gerente
    });
  };

  onEditLider = (lider: LiderComercial) => {
    this.setState({
      popupEmpleadoOpen: true,
      popupEmpleadoTitle: "Líder Comercial",
      popupEmpleadoMessage: "Seleccione al Líder Comercial",
      popupEmpleadoFormConfig: empleadoFormConfig,
      popupEmpleadoInit: { idUser: lider.idUser },
      popupEmpleadoHandler: this.handleSaveLider,
      popupEmpleadoDanger: this.state.plantilla.confirmado
        ? "Plantilla confirmada: Los alcances del Líder se asignarán al que está especificando."
        : null,
      lider: lider
    });
  };

  onDeleteLider = (lider: LiderComercial) => {
    const { plantilla } = this.state;

    if (!lider.idUser) {
      errorNotification("No ha seleccionado al Líder Comercial");
      return;
    }

    if (plantilla.confirmado) {
      this.setState({
        popupEmpleadoOpen: true,
        popupEmpleadoTitle: "Líder Comercial",
        popupEmpleadoMessage: "Baja del Líder Comercial",
        popupEmpleadoFormConfig: bajaFormConfig,
        popupEmpleadoInit: undefined,
        popupEmpleadoHandler: this.handleBajaLider,
        popupEmpleadoDanger: this.state.plantilla.confirmado
          ? "Plantilla confirmada: Los alcances del Líder se congelarán hasta la fecha de baja que ingrese; se ignorarán las operaciones subsecuentes."
          : null,
        lider: lider
      });
    } else {
      this.setState({
        confirmModalOpen: true,
        confirmModalTitle: "Líder Comercial",
        confirmModalMessage: `¿Está seguro de eliminar al Líder ${lider.nombreEmpleado} del club ${lider.nombreClub}?`,
        confirmModalHandler: () => this.handleDeleteLider(lider),
        lider: lider
      });
    }
  };

  onEditAsesor = (asesor: AsesorClub, lider: LiderComercial) => {
    this.setState({
      popupEmpleadoOpen: true,
      popupEmpleadoTitle: "Asesor de Club",
      popupEmpleadoMessage: "Seleccione al Asesor de Club",
      popupEmpleadoFormConfig: asesorFormConfig,
      popupEmpleadoInit: {
        idUser: asesor.idUser,
        nuevoIngreso: asesor.nuevoIngreso
      },
      popupEmpleadoHandler: this.handleEditAsesor,
      popupEmpleadoDanger: this.state.plantilla.confirmado
        ? "Plantilla confirmada: Esta operación no se debería realizar, a menos que exista un error al especificar los asesores."
        : null,
      asesor: asesor,
      lider: lider
    });
  };

  onDeleteAsesor = (asesor: AsesorClub, lider: LiderComercial) => {
    const { plantilla } = this.state;

    if (plantilla.confirmado) {
      this.setState({
        popupEmpleadoOpen: true,
        popupEmpleadoTitle: "Asesor de Club",
        popupEmpleadoMessage: "Baja del Asesor de Club",
        popupEmpleadoFormConfig: bajaFormConfig,
        popupEmpleadoInit: undefined,
        popupEmpleadoHandler: this.handleBajaAsesor,
        popupEmpleadoDanger: this.state.plantilla.confirmado
          ? "Plantilla confirmada: Las ventas realizadas por el asesor, a partir de la fecha de baja, no se considerarán para el alcance individual."
          : null,
        asesor: asesor,
        lider: lider
      });
    } else {
      this.setState({
        confirmModalOpen: true,
        confirmModalTitle: "Eliminar Asesor",
        confirmModalMessage: `¿Está seguro de eliminar al asesor ${asesor.nombreEmpleado} del club ${asesor.nombreClub}?`,
        confirmModalHandler: () => this.handleDeleteAsesor(asesor, lider),
        asesor: asesor,
        lider: lider
      });
    }
  };

  onAddAsesor = (lider: LiderComercial) => {
    this.setState({
      popupEmpleadoOpen: true,
      popupEmpleadoTitle: "Agregar Asesor",
      popupEmpleadoMessage: "Seleccione al empleado y configure las opciones",
      popupEmpleadoFormConfig: asesorFormConfig,
      popupEmpleadoInit: undefined,
      popupEmpleadoHandler: this.handleAddAsesor,
      popupEmpleadoDanger: this.state.plantilla.confirmado
        ? "Plantilla confirmada: No se dividirán los alcances establecidos para el nuevo asesor."
        : null,
      lider: lider
    });
  };

  onCambiarMetas = (gerente: GerenteRegional) => {
    this.setState({
      popupEmpleadoOpen: true,
      popupEmpleadoTitle: "Cambiar Metas",
      popupEmpleadoMessage: `Región ${gerente.numeroRegion}`,
      popupEmpleadoFormConfig: metasPresupuestadasFormConfig,
      popupEmpleadoInit: {
        metaVentas: gerente.metaVentas,
        metaReactivaciones: gerente.metaReactivaciones,
        metaConsolidada: gerente.metaConsolidada
      },
      popupEmpleadoHandler: this.handleCambiarMetas,
      popupEmpleadoDanger: null,
      gerente: gerente
    });
  };

  handleCambiarMetas = async (values: any) => {
    const { gerente } = this.state;

    if (!gerente || !gerente.id) {
      errorNotification(
        "Debe guardar la plantilla antes de cambiar las metas presupuestadas"
      );
      return;
    }

    const preview = await this.props.putRegionMetas(gerente.id, {
      metaVentas: values.metaVentas,
      metaReactivaciones: values.metaReactivaciones,
      metaConsolidada: values.metaConsolidada
    });

    if (preview.fulfilled) {
      successNotification("Metas actualizadas exitosamente");
      this.closePopupEmpleado();
      await this.loadPlantilla();
    } else {
      errorNotification(preview.puttingRegionMetasError);
    }
  };

  onCambiarMetasClub = (lider: LiderComercial) => {
    this.setState({
      popupEmpleadoOpen: true,
      popupEmpleadoTitle: "Cambiar Metas",
      popupEmpleadoMessage: `${lider.nombreClub}`,
      popupEmpleadoFormConfig: metasFormConfig,
      popupEmpleadoInit: {
        metaVentas: lider.metaVentas,
        metaReactivaciones: lider.metaReactivaciones,
        metaConsolidada: lider.metaConsolidada,
        observaciones: ""
      },
      popupEmpleadoHandler: this.handleCambiarMetasClub,
      popupEmpleadoDanger: null,
      lider: lider
    });
  };

  handleCambiarMetasClub = async (values: any) => {
    const { lider } = this.state;

    if (!lider || !lider.id) {
      errorNotification("Debe guardar la plantilla antes de cambiar las metas");
      return;
    }

    const preview = await this.props.putClubMetas(lider.id, {
      metaVentas: values.metaVentas,
      metaReactivaciones: values.metaReactivaciones,
      metaConsolidada: values.metaConsolidada,
      observaciones: values.observaciones
    });

    if (preview.fulfilled) {
      successNotification("Metas actualizadas exitosamente");
      this.closePopupEmpleado();
      await this.loadPlantilla();
    } else {
      errorNotification(preview.puttingClubMetasError);
    }
  };

  onCambiarMetasAsesores = (lider: LiderComercial) => {
    // Encontrar el primer asesor
    const asesor =
      lider.asesores.length > 0 ? lider.asesores[0] : ({} as AsesorClub);

    this.setState({
      popupEmpleadoOpen: true,
      popupEmpleadoTitle: "Cambiar Metas de Asesores",
      popupEmpleadoMessage: `${lider.nombreClub} - Se aplicará a todos los asesores`,
      popupEmpleadoFormConfig: metasFormConfig,
      popupEmpleadoInit: {
        metaVentas: asesor.metaVentas || 0,
        metaReactivaciones: asesor.metaReactivaciones || 0,
        metaConsolidada: asesor.metaConsolidada || 0,
        observaciones: ""
      },
      popupEmpleadoHandler: this.handleCambiarMetasAsesores,
      popupEmpleadoDanger: null,
      lider: lider
    });
  };

  handleCambiarMetasAsesores = async (values: any) => {
    const { lider } = this.state;

    if (!lider || !lider.id) {
      errorNotification("Debe guardar la plantilla antes de cambiar las metas");
      return;
    }

    const preview = await this.props.putAsesoresMetas(lider.id, {
      metaVentas: values.metaVentas,
      metaReactivaciones: values.metaReactivaciones,
      metaConsolidada: values.metaConsolidada,
      observaciones: values.observaciones
    });

    if (preview.fulfilled) {
      successNotification("Metas actualizadas exitosamente");
      this.closePopupEmpleado();
      await this.loadPlantilla();
    } else {
      errorNotification(preview.puttingAsesoresMetasError);
    }
  };

  onGuardarPlantilla = () => {
    const { plantilla } = this.state;

    if (!plantilla) {
      errorNotification("No hay plantilla para guardar");
      return;
    }

    this.setState({
      confirmModalOpen: true,
      confirmModalTitle: "Confirmar Guardado",
      confirmModalMessage: "Confirme los cambios realizados en su plantilla.",
      confirmModalHandler: this.handleGuardarPlantilla
    });
  };

  handleGuardarPlantilla = async () => {
    const { plantilla } = this.state;
    this.closeConfirmModal();

    const preview = await this.props.postPlantilla(plantilla);
    if (preview.fulfilled) {
      this.setState({ plantilla: preview.plantillaGuardada, guardar: false });
      successNotification("Plantilla guardada exitosamente");
    } else {
      errorNotification(preview.postingComisionMembresiaPlantillaError);
    }
  };

  onConfirmarPlantilla = () => {
    const { plantilla } = this.state;

    if (!plantilla || !plantilla.id) {
      errorNotification("Debe guardar la plantilla antes de confirmarla");
      return;
    }

    this.setState({
      confirmModalOpen: true,
      confirmModalTitle: "Confirmar Plantilla",
      confirmModalMessage:
        "Al confirmar la plantilla, se congelará para el periodo.",
      confirmModalHandler: this.handleConfirmarPlantilla
    });
  };

  handleConfirmarPlantilla = async () => {
    const { plantilla } = this.state;
    this.closeConfirmModal();

    const preview = await this.props.confirmarPlantilla(plantilla.id);
    if (preview.fulfilled) {
      successNotification("Plantilla confirmada exitosamente");
      await this.loadPlantilla();
    } else {
      errorNotification(
        preview.postingComisionMembresiaPlantillaConfirmarError
      );
    }
  };

  onDescartarPlantilla = () => {
    const { plantilla } = this.state;

    if (!plantilla || !plantilla.periodo) {
      errorNotification("No hay plantilla para descartar");
      return;
    }

    this.setState({
      confirmModalOpen: true,
      confirmModalTitle: "Descartar Plantilla",
      confirmModalMessage:
        "¿Está seguro de descartar los cambios en esta plantilla?",
      confirmModalHandler: this.handleDescartarPlantilla
    });
  };

  handleDescartarPlantilla = async () => {
    const { plantilla } = this.state;
    this.closeConfirmModal();

    const preview = await this.props.deletePlantillaByPeriodo(
      plantilla.periodo
    );
    if (preview.fulfilled) {
      successNotification("Plantilla descartada exitosamente");
      await this.loadPlantilla();
    } else {
      errorNotification(preview.deletingComisionMembresiaPlantillaError);
    }
  };

  closePopupEmpleado = () => {
    this.setState({
      popupEmpleadoOpen: false,
      popupEmpleadoTitle: "",
      popupEmpleadoMessage: "",
      popupEmpleadoFormConfig: null,
      popupEmpleadoInit: null,
      popupEmpleadoHandler: null,
      gerente: null,
      lider: null,
      asesor: null
    });
  };

  closeConfirmModal = () => {
    this.setState({
      confirmModalOpen: false,
      confirmModalTitle: "",
      confirmModalMessage: "",
      confirmModalHandler: null
    });
  };

  handleDeleteGerente = (gerente: GerenteRegional) => {
    gerente.idUser = null;
    gerente.nombreEmpleado = "";
    gerente.numeroEmpleado = "";

    this.setState({ plantilla: { ...this.state.plantilla }, guardar: true });
    successNotification("Gerente eliminado correctamente");
    this.closeConfirmModal();
  };

  handleDeleteLider = (lider: LiderComercial) => {
    lider.idUser = null;
    lider.nombreEmpleado = "";
    lider.numeroEmpleado = "";

    this.setState({ plantilla: { ...this.state.plantilla }, guardar: true });
    successNotification("Líder eliminado correctamente");
    this.closeConfirmModal();
  };

  handleBajaLider = (values: any) => {
    const { lider, plantilla } = this.state;

    lider.fechaBaja = values.fechaBaja;

    this.setState({ plantilla: { ...plantilla }, guardar: true });
    successNotification("Líder dado de baja correctamente");
    this.closePopupEmpleado();
  };

  handleDeleteAsesor = (asesor: AsesorClub, lider: LiderComercial) => {
    const { plantilla } = this.state;

    const index = lider.asesores.indexOf(asesor);
    lider.asesores.splice(index, 1);
    const totalAsesores = lider.asesores.length;
    const metaVentas = Math.ceil(lider.metaVentas / totalAsesores);
    const metaReactivaciones = Math.ceil(
      lider.metaReactivaciones / totalAsesores
    );
    const metaConsolidada = Math.ceil(lider.metaConsolidada / totalAsesores);

    // Actualizar alcances de asesores existentes
    lider.asesores.forEach(asesor => {
      asesor.metaVentas = metaVentas;
      asesor.metaReactivaciones = metaReactivaciones;
      asesor.metaConsolidada = metaConsolidada;
    });

    this.setState({ plantilla: { ...plantilla }, guardar: true });
    successNotification("Asesor eliminado correctamente");
    this.closeConfirmModal();
  };

  handleBajaAsesor = (values: any) => {
    const { asesor, plantilla } = this.state;

    asesor.fechaBaja = values.fechaBaja;

    this.setState({ plantilla: { ...plantilla }, guardar: true });
    successNotification("Asesor dado de baja correctamente");
    this.closePopupEmpleado();
  };

  formatPeriodo = (periodo: string): string => {
    const meses = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ];

    const [year, month] = periodo.split("-");
    const monthIndex = parseInt(month, 10) - 1;

    return `${meses[monthIndex]} ${year}`;
  };

  handleSaveGerente = async (values: any) => {
    const { gerente, plantilla } = this.state;
    const empleados = await getEmployeesBasicCatalog(
      false,
      false,
      values.idUser
    );
    const empleado = empleados.find(e => e.userId === values.idUser);

    if (!empleado) {
      errorNotification("No se encontró al empleado seleccionado");
      return;
    }

    gerente.idUser = empleado.userId;
    gerente.numeroEmpleado = empleado.employeeNumber.toString();
    gerente.nombreEmpleado = empleado.name;

    this.setState({ plantilla: { ...plantilla }, guardar: true });
    successNotification("Gerente actualizado correctamente");
    this.closePopupEmpleado();
  };

  handleSaveLider = async (values: any) => {
    const { lider, plantilla } = this.state;
    const empleados = await getEmployeesBasicCatalog(
      false,
      false,
      values.idUser
    );
    const empleado = empleados.find(e => e.userId === values.idUser);

    if (!empleado) {
      errorNotification("No se encontró al empleado seleccionado");
      return;
    }

    lider.idUser = empleado.userId;
    lider.numeroEmpleado = empleado.employeeNumber.toString();
    lider.nombreEmpleado = empleado.name;

    this.setState({ plantilla: { ...plantilla }, guardar: true });
    successNotification("Líder actualizado correctamente");
    this.closePopupEmpleado();
  };

  handleEditAsesor = async (values: any) => {
    const { asesor, lider, plantilla } = this.state;
    const empleados = await getEmployeesBasicCatalog(
      false,
      false,
      values.idUser
    );
    const empleado = empleados.find(e => e.userId === values.idUser);

    if (!empleado) {
      errorNotification("No se encontró al empleado seleccionado");
      return;
    }

    if (
      lider.asesores.some(
        a => a.idUser === empleado.userId && a.idUser !== asesor.idUser
      )
    ) {
      errorNotification(`Este asesor ya pertenece al club ${lider.nombreClub}`);
      return;
    }

    asesor.idUser = empleado.userId;
    asesor.numeroEmpleado = empleado.employeeNumber.toString();
    asesor.nombreEmpleado = empleado.name;
    asesor.nuevoIngresoMarcado =
      asesor.nuevoIngresoMarcado ||
      !!values.nuevoIngreso !== !!asesor.nuevoIngreso;
    asesor.nuevoIngreso = values.nuevoIngreso;

    this.setState({ plantilla: { ...plantilla }, guardar: true });
    successNotification("Asesor actualizado correctamente");
    this.closePopupEmpleado();
  };

  handleDownloadReporteMetasClub = () => {
    const { plantilla } = this.state;

    if (!plantilla || !plantilla.periodo) {
      errorNotification("No hay plantilla para descargar");
      return;
    }

    this.setState({ loadingReporte: true });
    downloadReporteMetasClub(plantilla.periodo, error => {
      this.setState({ loadingReporte: false });
      if (!error) {
        successNotification("Reporte descargado exitosamente");
      }
    });
  };

  handleFiltrosChange = (values: any) => {
    this.setState({
      filtros: {
        tipoBusqueda: values.tipoBusqueda || "",
        region: values.region || null,
        club: values.club || null
      }
    });
  };

  getOpcionesRegiones = () => {
    const { plantilla } = this.state;
    if (!plantilla || !plantilla.gerentes) return [];

    return plantilla.gerentes.map(gerente => ({
      value: gerente.numeroRegion,
      label: `Región ${gerente.numeroRegion}`
    }));
  };

  getOpcionesClubes = () => {
    const { plantilla } = this.state;
    if (!plantilla || !plantilla.gerentes) return [];

    const clubes: Array<{ value: number; label: string }> = [];
    plantilla.gerentes.forEach(gerente => {
      if (gerente.lideres) {
        gerente.lideres.forEach(lider => {
          clubes.push({
            value: lider.idClub,
            label: lider.nombreClub
          });
        });
      }
    });

    return clubes;
  };

  handleAddAsesor = async (values: any) => {
    const { lider, plantilla } = this.state;
    const empleados = await getEmployeesBasicCatalog(
      false,
      false,
      values.idUser
    );
    const empleado = empleados.find(e => e.userId === values.idUser);

    if (!empleado) {
      errorNotification("No se encontró al empleado seleccionado");
      return;
    }

    if (lider.asesores.some(a => a.idUser === empleado.userId)) {
      errorNotification(`Este asesor ya pertenece al club ${lider.nombreClub}`);
      return;
    }

    let metaVentas: number;
    let metaReactivaciones: number;
    let metaConsolidada: number;

    // REQ: Concepción Estrada - No actualizar metas en plantillas confirmadas
    if (plantilla.confirmado) {
      const asesor = lider.asesores.length > 0 ? lider.asesores[0] : null;
      metaVentas = asesor ? asesor.metaVentas : lider.metaVentas;
      metaReactivaciones = asesor
        ? asesor.metaReactivaciones
        : lider.metaReactivaciones;
      metaConsolidada = asesor ? asesor.metaConsolidada : lider.metaConsolidada;
    } else {
      const totalAsesores = lider.asesores.length + 1;
      metaVentas = Math.ceil(lider.metaVentas / totalAsesores);
      metaReactivaciones = Math.ceil(lider.metaReactivaciones / totalAsesores);
      metaConsolidada = Math.ceil(lider.metaConsolidada / totalAsesores);

      // Actualizar alcances de asesores existentes
      lider.asesores.forEach(asesor => {
        asesor.metaVentas = metaVentas;
        asesor.metaReactivaciones = metaReactivaciones;
        asesor.metaConsolidada = metaConsolidada;
      });
    }

    lider.asesores.push({
      idClub: lider.idClub,
      nombreClub: lider.nombreClub,
      claveCorta: lider.claveCorta,
      idUser: empleado.userId,
      numeroEmpleado: empleado.employeeNumber.toString(),
      nombreEmpleado: empleado.name,
      nuevoIngreso: values.nuevoIngreso,
      nuevoIngresoMarcado: values.nuevoIngreso,
      metaVentas: metaVentas,
      metaReactivaciones: metaReactivaciones,
      metaConsolidada: metaConsolidada
    });

    this.setState({ plantilla: { ...plantilla }, guardar: true });
    successNotification("Asesor agregado correctamente");
    this.closePopupEmpleado();
  };

  render() {
    const {
      gettingComisionMembresiaPlantilla: loadingPlantilla,
      postingComisionMembresiaPlantilla: loadingGuardar,
      postingComisionMembresiaPlantillaConfirmar: loadingConfirmar,
      deletingComisionMembresiaPlantilla: loadingDescartar
    } = this.props;
    const { plantilla, loadingReporte } = this.state;

    return (
      <div className="container">
        {loadingPlantilla && (
          <div className="row">
            <div className="col-md-12 text-center">
              <p>Cargando plantilla...</p>
            </div>
          </div>
        )}

        {plantilla && (
          <>
            <div className={s.stickyButtonBar}>
              <div className="row">
                <div className={`col-3 ${s.periodo}`}>
                  Periodo: {this.formatPeriodo(plantilla.periodo)}
                </div>
                <div className={`col-5 ${s.filtros}`}>
                  <div className={`container`}>
                    <FormBuilder
                      config={filtrosFormConfig}
                      init={this.state.filtros}
                      onChange={this.handleFiltrosChange}
                    >
                      <ISelectBuilder
                        name="region"
                        data={this.getOpcionesRegiones()}
                      />
                      <ITypeSelectBuilder
                        name="club"
                        data={this.getOpcionesClubes()}
                      />
                    </FormBuilder>
                  </div>
                </div>
                <div className={`col-4 ${s.buttonBar}`}>
                  <Button
                    color="primary"
                    className="mr-2"
                    onClick={this.onGuardarPlantilla}
                    hidden={!this.state.guardar}
                    disabled={
                      loadingGuardar ||
                      loadingConfirmar ||
                      loadingDescartar ||
                      loadingReporte
                    }
                  >
                    {loadingGuardar ? (
                      <>
                        <FontAwesomeIcon icon={faSpinner} pulse /> Guardando...
                      </>
                    ) : !plantilla.id ? (
                      "Guardar Plantilla"
                    ) : (
                      "Guardar Cambios"
                    )}
                  </Button>
                  <Button
                    color="success"
                    className="mr-2"
                    onClick={this.onConfirmarPlantilla}
                    hidden={plantilla.confirmado || this.state.guardar}
                    disabled={
                      loadingGuardar ||
                      loadingConfirmar ||
                      loadingDescartar ||
                      loadingReporte
                    }
                  >
                    {loadingConfirmar ? (
                      <>
                        <FontAwesomeIcon icon={faSpinner} pulse />{" "}
                        Confirmando...
                      </>
                    ) : (
                      "Confirmar Plantilla"
                    )}
                  </Button>
                  <Button
                    color="success"
                    className="mr-2"
                    onClick={this.handleDownloadReporteMetasClub}
                    hidden={!plantilla.confirmado || this.state.guardar}
                    disabled={
                      loadingGuardar ||
                      loadingConfirmar ||
                      loadingDescartar ||
                      loadingReporte
                    }
                  >
                    {loadingReporte ? (
                      <>
                        <FontAwesomeIcon icon={faSpinner} pulse />{" "}
                        Descargando...
                      </>
                    ) : (
                      "Reporte de Metas"
                    )}
                  </Button>
                  <Button
                    color="danger"
                    onClick={this.onDescartarPlantilla}
                    hidden={!plantilla.id}
                    disabled={
                      loadingGuardar ||
                      loadingConfirmar ||
                      loadingDescartar ||
                      loadingReporte
                    }
                  >
                    {loadingDescartar ? (
                      <>
                        <FontAwesomeIcon icon={faSpinner} pulse />{" "}
                        Descartando...
                      </>
                    ) : (
                      "Descartar Plantilla"
                    )}
                  </Button>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <ConfiguracionPlantillaTable
                  plantilla={plantilla}
                  filtros={this.state.filtros}
                  onEditGerente={this.onEditGerente}
                  onDeleteGerente={this.onDeleteGerente}
                  onEditLider={this.onEditLider}
                  onDeleteLider={this.onDeleteLider}
                  onEditAsesor={this.onEditAsesor}
                  onDeleteAsesor={this.onDeleteAsesor}
                  onAddAsesor={this.onAddAsesor}
                  onCambiarMetas={this.onCambiarMetas}
                  onCambiarMetasClub={this.onCambiarMetasClub}
                  onCambiarMetasAsesores={this.onCambiarMetasAsesores}
                />
              </div>
            </div>
          </>
        )}

        <FormBuilderModal
          isOpen={this.state.popupEmpleadoOpen}
          title={this.state.popupEmpleadoTitle}
          message={this.state.popupEmpleadoMessage}
          ok={this.state.popupEmpleadoHandler}
          cancel={this.closePopupEmpleado}
          formConfig={this.state.popupEmpleadoFormConfig}
          values={this.state.popupEmpleadoInit}
          danger={this.state.popupEmpleadoDanger}
          size="md"
        />

        <ConfirmModal
          isOpen={this.state.confirmModalOpen}
          title={this.state.confirmModalTitle}
          message={this.state.confirmModalMessage}
          ok={this.state.confirmModalHandler}
          cancel={this.closeConfirmModal}
          requireInput={false}
          inputType=""
          inputTitle=""
          waiting={false}
          options={[]}
          size="md"
          currentValue={null}
          okTitle="Confirmar"
          cancelTitle="Cancelar"
        />
      </div>
    );
  }
}
